import { useEffect, useState } from "react";
import useDataContext from "../../providers/DataProvider/useDataContext"
import { subscribeToScroll } from "../../assets/scripts/ScrollManager";
import { InstagramIcon } from "../Icons/Icons";
import "./InstagramButton.css";

interface Props {
    isHomePage: boolean
}

const InstagramButton: React.FC<Props> = ({ isHomePage }) => {
    const { data } = useDataContext();
    const [isFixed, setIsFixed] = useState(!isHomePage);

    useEffect(() => {
        if (isHomePage) {
            const unsuscribe = subscribeToScroll(setIsFixed);

            return () => {
                unsuscribe();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={`fixed bottom-[152px] lg:bottom-44 right-1 lg:right-3 z-40 size-14 lg:size-16
                       bg-forth-solid rounded-full border-4 border-first-solid
                         transition duration-500 ease-out opacity-0
                       hover:bg-third-solid
                      ${ isFixed ? "isFixed" : ""}`}>
            <a aria-label="instagram-link"
               href={ data.components.instagramLink }
               target="_blank"
               rel="noreferrer"
               className="size-full flex justify-center items-center">
                <InstagramIcon className="size-6 lg:size-8 text-first-solid"/>
            </a>
        </div>
    )
}

export default InstagramButton
